module.exports = __webpack_public_path__ + "static/media/collapse.6fb5dbd9.svg";